module.exports = __webpack_public_path__ + "static/linkedin_logo-6692e86bece9a45bc8b594a723bdf07e.png";